'use strict';
angular.module('schoolLinqApp').directive('imageCheckBox', function () {
	return {
		scope: {
			showCheckCondition: '=',
			showEmptyCondition: '=',
			disabled: '=',
			checkClickFunction: '&',
			emptyClickFunction: '&',
			checkedFaImage: '@',
			checkedFaImage2: '@',
			unCheckedFaImage: '@',
			unCheckedFaImage2: '@',
			imageSize: '@',
			checkedImageColorClass: '@',
			emptyImageColorClass: '@',
			clickable: '@',
			containerStyle: '@',
		},
		replace: true,
		compile: function (element, attrs) {
			//Default to the blue checked and unchecked square images we've been using, but the directive can override this.
			if (!attrs.checkedFaImage) {
				attrs.checkedFaImage = 'fa-check-square-o';
			}
			if (!attrs.unCheckedFaImage) {
				attrs.unCheckedFaImage = 'fa-square-o';
			}
			attrs.checkedFaImage2 = attrs.checkedFaImage;
			attrs.unCheckedFaImage2 = attrs.unCheckedFaImage;

			if (!attrs.imageSize) {
				attrs.imageSize = 'fa-2x';
			}
			if (!attrs.checkedImageColorClass) {
				attrs.checkedImageColorClass = 'checkedPrimaryImage';
			}
			if (!attrs.emptyImageColorClass) {
				attrs.emptyImageColorClass = 'checkedPrimaryImage';
			}

			//If the size specified wasn't normal (2x), update the template with the correct size. Performing the normal
			//{{}} binding in the template resulted in both images being visible.
			if (attrs.imageSize !== 'fa-2x') {
				element.html(element.html().replace(/fa-2x/gi, attrs.imageSize));
			}

			if (attrs.checkedImageColorClass !== 'checkedPrimaryImage') {
				var checkedTag = element.find('.checkedImage');
				checkedTag[0].outerHTML = checkedTag[0].outerHTML.replace('checkedPrimaryImage', attrs.checkedImageColorClass);
			}

			if (attrs.emptyImageColorClass !== 'checkedPrimaryImage') {
				var emptyTag = element.find('.emptyImage');
				emptyTag[0].outerHTML = emptyTag[0].outerHTML.replace('checkedPrimaryImage', attrs.emptyImageColorClass);
			}

			//By default Angular will merge attributes from the image-check-box element, but we don't want to apply
			//the ng-show element here, so we remove all attributes from the main DIV in the template.
			while (element[0].attributes.length > 0) {
				element[0].removeAttribute(element[0].attributes[0].name);
			}

			//Add back a class attribute to format the overall div.
			$(element).addClass('imageCheckboxContainer');

			if (!attrs.clickable || attrs.clickable === 'true') {
				element.addClass('clickable');
			}

			//Apply an event handler for the click function.
			return function (scope, element, attrs) {
				var checkedTag = element.find('.checkedImage');
				var emptyTag = element.find('.emptyImage');

				checkedTag.click(function () {
					scope.$apply(function () {
						if (!scope.disabled) {
							scope.checkClickFunction();
						}
					});
				});

				emptyTag.click(function () {
					scope.$apply(function () {
						if (!scope.disabled) {
							scope.emptyClickFunction();
						}
					});
				});

				checkedTag.mouseover(function () {
					scope.$apply(function () {
						if (scope.disabled) {
							scope.checkedFaImage2 = attrs.checkedFaImage + ' fa-disabled';
						} else {
							scope.checkedFaImage2 = attrs.checkedFaImage;
						}
					});
				});

				emptyTag.mouseover(function () {
					scope.$apply(function () {
						if (scope.disabled) {
							scope.unCheckedFaImage2 = attrs.unCheckedFaImage + ' fa-disabled';
						} else {
							scope.unCheckedFaImage2 = attrs.unCheckedFaImage;
						}
					});
				});
			};
		},
		restrict: 'E',
		template:
			'<div class="imageCheckboxContainer clickable {{containerStyle}}"><i class="fa {{checkedFaImage2}} fa-2x checkedImage checkedPrimaryImage" aria-hidden="true" ng-show="showCheckCondition" ng-hide="!showCheckCondition"></i><i class="fa {{unCheckedFaImage2}} fa-2x emptyImage checkedPrimaryImage" aria-hidden="true" ng-show="showEmptyCondition" ng-hide="!showEmptyCondition"></i></div>',
	};
});
